import ModelService from './model.service';

const NotificationService = new ModelService('/notifications', '/notifications', 'animations');

NotificationService.getImage = (filename, w = false, h = false, c = false) => NotificationService.getFilePathByDir('/uploads/fonts', filename, w, h, c);

NotificationService.STATUS_INACTIVE = 0;
NotificationService.STATUS_ACTIVE = 1;

NotificationService.getStatusList = t => ({
  [NotificationService.STATUS_INACTIVE]: t('Inactive'),
  [NotificationService.STATUS_ACTIVE]: t('Active'),
});

NotificationService.getStatusOptions = t => NotificationService
  .prepareOptionsFromSimpleObject(NotificationService.getStatusList(t));

NotificationService.getColorByStatus = (status) => {
  switch (status) {
    case NotificationService.STATUS_INACTIVE:
      return 'danger';
    case NotificationService.STATUS_ACTIVE:
      return 'success';
    default:
      return 'secondary';
  }
};

NotificationService.getStatusTitle = (status, t) => {
  const label = NotificationService.getStatusList(t)[status];
  return label || '-';
};

NotificationService.TYPE_ALL_COMPANIES = 1;
NotificationService.TYPE_NEW_COMPANIES = 2;
NotificationService.TYPE_SELECTED_COMPANIES = 3;

NotificationService.getTypesList = t => ({
  [NotificationService.TYPE_ALL_COMPANIES]: t('All companies'),
  [NotificationService.TYPE_NEW_COMPANIES]: t('New companies'),
  [NotificationService.TYPE_SELECTED_COMPANIES]: t('Selected companies'),
});

NotificationService.getTypesOptions = t => NotificationService
  .prepareOptionsFromSimpleObject(NotificationService.getTypesList(t));

NotificationService.getTypesTitle = (status, t) => {
  const label = NotificationService.getTypesList(t)[status];
  return label || '-';
};

export default NotificationService;



// WEBPACK FOOTER //
// ./src/services/notification.service.js